var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTbaAnalysisSplashImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "282px",
    height: "120px",
    viewBox: "0 0 282 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1DC715A0-83CC-421A-801D-E3F25B26B588") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-designs-current",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TP_DIY-TBA-Uncontrolled-Splash",
    transform: "translate(-964.000000, -221.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TBA-Uncontrolled-Search-Illus",
    transform: "translate(964.000000, 221.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-64",
    transform: "translate(81.000000, 60.000000)",
    fill: "#EFEFF2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-63",
    transform: "translate(30.000000, 30.000000) rotate(-270.000000) translate(-30.000000, -30.000000) ",
    points: "-6.00247052e-13 1.687539e-14 60 1.36779477e-13 60 60 -6.00933527e-13 60"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-66",
    transform: "translate(141.000000, 0.000000)",
    fill: "#EFEFF2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-63",
    transform: "translate(30.000000, 30.000000) rotate(-270.000000) translate(-30.000000, -30.000000) ",
    points: "-1.0549944e-12 4.43201031e-13 60 5.63105118e-13 60 60 -1.05568088e-12 60"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-64",
    transform: "translate(81.000000, 0.000000)",
    fill: "#FAF9FA"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-63",
    transform: "translate(30.000000, 30.000000) rotate(-270.000000) translate(-30.000000, -30.000000) ",
    points: "-4.15200375e-14 -1.14432273e-14 60 -1.18803776e-14 60 60 -4.22548256e-14 60"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-65",
    transform: "translate(141.000000, 60.000000)",
    fill: "#FAF9FA"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-63",
    transform: "translate(30.000000, 30.000000) rotate(-270.000000) translate(-30.000000, -30.000000) ",
    points: "-4.84694476e-13 4.20108393e-13 60 4.19220214e-13 60 60 -4.85429264e-13 60"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-71",
    fill: "#DCDBFE",
    transform: "translate(252.000000, 59.000000) rotate(-270.000000) translate(-252.000000, -59.000000) ",
    x: 224,
    y: 29,
    width: 56,
    height: 60
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-72",
    fill: "#EFEFFF",
    transform: "translate(30.000000, 60.000000) rotate(-270.000000) translate(-30.000000, -60.000000) ",
    x: 2,
    y: 30,
    width: 56,
    height: 60
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(107.000000, 24.000000)",
    fill: "#6E56DB",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.874454,0 C14.7196652,0 0,14.731352 0,32.9005549 C0,51.0690931 14.7190008,65.7973248 32.874454,65.7973248 C51.0292429,65.7973248 65.745126,51.0697579 65.745126,32.9005549 C65.745126,14.730687 51.0285786,0 32.874454,0 Z M32.874454,3.06034069 C49.3396259,3.06034069 62.6872132,16.4207524 62.6872132,32.9005549 C62.6872132,49.3795784 49.3404042,62.7369841 32.874454,62.7369841 C16.4077253,62.7369841 3.05791284,49.3787994 3.05791284,32.9005549 C3.05791284,16.4215315 16.4085038,3.06034069 32.874454,3.06034069 Z",
    id: "Stroke-1-Copy-11"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-3-Copy",
    points: "57.652523 52.4739682 76 70.8360123 73.8377291 73 55.4902521 54.6379559"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    d: "M230.5,97.5 L221.5,93 L230.5,88.5 L230.5,92.5 L252.5,92.5 L252.5,112 L251.5,112 L251.5,93.5 L230.5,93.5 L230.5,97.5 Z",
    transform: "translate(237.000000, 102.500000) scale(1, -1) translate(-237.000000, -102.500000) ",
    fill: "#6E56DB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    d: "M38.5,12.5 L29.5,8 L38.5,3.5 L38.5,7.5 L60.5,7.5 L60.5,27 L59.5,27 L59.5,8.5 L38.5,8.5 L38.5,12.5 Z",
    transform: "translate(45.000000, 17.500000) scale(-1, 1) translate(-45.000000, -17.500000) ",
    fill: "#6E56DB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon/UploadSmall",
    transform: "translate(21.000000, 49.000000)",
    fill: "#3C2A8E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,16 L2,18 L16,18 L16,16 L18,16 L18,20 L0,20 L0,16 L2,16 Z M8.00000002,14.4142136 L8.00000002,3.8302136 L3.7071068,8.12132038 L2.29289322,6.70710682 L9.00000002,0 L15.7071068,6.70710682 L14.2928932,8.12132038 L10,3.8282136 L10,14.4142136 L8.00000002,14.4142136 Z",
    id: "Upload"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M252.755527,66.3198037 L252.755527,58.984142 C254.091598,59.3301869 255.0747,59.7817633 255.70957,60.3413253 C256.342072,60.9008873 256.657138,61.669058 256.657138,62.6531999 C256.657138,63.6152539 256.311276,64.432509 255.612445,65.1074193 C254.913613,65.7823296 253.963677,66.1848216 252.755527,66.3198037 L252.755527,66.3198037 Z M250.744315,56.2673211 C248.422773,55.5555975 247.262003,54.4070228 247.262003,52.831414 C247.262003,51.9626204 247.579438,51.2459883 248.223784,50.6790636 C248.863392,50.1121389 249.704359,49.7587314 250.744315,49.6237493 L250.744315,56.2673211 Z M252.755527,45 L250.744315,45 L250.744315,47.5450255 C249.038692,47.6971871 247.655243,48.2641118 246.605812,49.2335284 C245.55638,50.2078535 245.03048,51.4055126 245.03048,52.831414 C245.03048,55.7764773 246.935092,57.6809515 250.744315,58.5497451 L250.744315,66.290353 C249.48168,66.0989239 248.441725,65.5688125 247.624447,64.7024731 C246.804801,63.8361337 246.286008,62.643383 246.063329,61.121767 L244,62.2482537 C244.258212,63.9048518 244.985471,65.3037568 246.174668,66.4498773 C247.363866,67.598452 248.88945,68.2659996 250.744315,68.4574287 L250.744315,71 L252.755527,71 L252.755527,68.4574287 C254.612761,68.2856334 256.117025,67.6401737 257.273057,66.5235039 C258.424352,65.4068341 259,64.0570134 259,62.4814046 C259,60.9180668 258.483575,59.6762318 257.450726,58.7509911 C256.420246,57.8282046 254.85439,57.1655654 252.755527,56.758165 L252.755527,49.6531999 C253.700726,49.8642628 254.529848,50.2986596 255.235786,50.951482 C255.941725,51.6092128 256.472363,52.4559184 256.825332,53.4940532 L258.722836,52.3405701 C258.294062,51.0103832 257.554959,49.9256183 256.505527,49.0887295 C255.456096,48.2518407 254.202937,47.7462715 252.755527,47.5720219 L252.755527,45 Z",
    id: "Fill-7-Copy-6",
    fill: "#6E56DB"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTbaAnalysisSplashImage);
export default __webpack_public_path__ + "static/media/TbaAnalysisSplashImage.53bbf3c4.svg";
export { ForwardRef as ReactComponent };